import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { LayersService } from '../_services/layers.service';
import { EventsService } from '../_services/events.service';
import { TabledataService } from '../_services/tabledata.service';
import { TreeNode } from 'primeng/api';
import { Mapapi } from '../ol-map/mapapi';
import { GlobalsService } from '../_services/globals.service';
import { ExportService } from '../_services/export.service';
import { LoginService } from '../login/login.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-layers-tree',
    templateUrl: './layers-tree.component.html',
    styleUrls: ['./layers-tree.component.css'],
    standalone: false
})
export class LayersTreeComponent implements OnInit {



    layerslist: TreeNode[] = [];
    private selectedlayers: TreeNode[] = [];
    private naseljaCqlDropBoxVals: any[] = [];
    private filters: {
        inbuild: string[];
        aditional: string;
        area: string;
    } = {
        inbuild: [],
        aditional: "",
        area: ""
    };


    midparameter: number;

    constructor(private ls: LayersService, private es: EventsService,
                private tableService: TabledataService, private api: Mapapi,
                private gs: GlobalsService, private exportService: ExportService,
                private los: LoginService, private messageService: MessageService) {

    }

    public nodeClick(node: any, doExpand: boolean, isExpanded: any): void {
        console.log(node);
        if (node.children === undefined || !node.children) {


            node.selected = !node.selected;

            this.nodeSelect({ checked: node.selected }, node, doExpand);
        }
        else {
            if (doExpand) {
                node.expanded = !node.expanded;
                isExpanded = node.expanded;
            }

            node.children.forEach((node: any) => {

                if (node.children === undefined) {
                    //node.styleClass = "endNode"
                    node.styleClass += " endNode"
                }

            });

            if (isExpanded && node.parent === undefined)
                node.styleClass = node.styleClassBg;
            else
                node.styleClass = "";

        }
    }

    public nodeCollapse(event: any): void {
        this.nodeClick(event.node, false, event.node.expanded); 
    }

        public nodeExpand(event: any): void {
        this.nodeClick(event.node, false, event.node.expanded); 
    }

    public setHiddenTree(v: boolean) {
        this.es.setVisibleTreeEvt(v);
    }


    public showInfo(event: any, node: any) {
        if (event.originalEvent !== undefined)
            event.originalEvent.stopPropagation();

        this.api.getLayerById(node.data.id).set("showinfo", node.data.info);
    }

    private tableOn(event: any, node: any) {

        if (event.originalEvent !== undefined)
            event.originalEvent.stopPropagation();

        node.data.tableOn = event.checked;

        // if ((node.data.additionalData !== undefined &&  node.data.additionalData.tabledataloaded === undefined ) || node.data.tabledataloaded === undefined )
        if ((node.data.additionalData !== undefined && node.data.additionalData.tabledataloaded === undefined) || (node.data.additionalData === undefined && node.data.tabledataloaded === undefined)) {
            //console.log("waitin for data callback !");
            var s1 = this.tableService.subscribeDataListener().subscribe(data => {
                s1.unsubscribe();
                this.tableService.setShowTable(node.data.id, node.data.tableOn, node.label, node);
            });
        }
        else {
            //console.log("loaded allready: on = "+node.data.tableOn);
            this.tableService.setShowTable(node.data.id, node.data.tableOn, node.label, node);

        }
        if (node.data.tableOn)//request only if table on
            this.tableService.setRequestTableData(node);

    }

    private nodeSelect(event: any, node: any, treeclick = false) {
        if (event.originalEvent !== undefined)
            event.originalEvent.stopPropagation();

        if (treeclick)
            node.data.removeLayerDetailView = treeclick;

        if (event.checked) {
            //console.log("manual check:"+treeclick);
            //console.log(node);
            this.selectedlayers.push(node);
            this.es.sendSelectNode(node);
            this.setCqlFilter(node);

            // custom layer naj obdrži svojo legendo in NE kliče GeoServerja
            if (node?.data?.type === 'custom') {
                // nič; node.data.legend je že nastavljen
            } else if (node?.data?.showlegend && node?.data?.url && node?.data?.layer) {
                node.data.legend = this.ls.getLayerLegend(
                    node.data.url,
                    node.data.layer,
                    node.data.legendStyle
                );
            }

            //if (node.data.additionalData !== undefined)
            //    this.tableOn(event,node);

            if (node?.data?.layertransparency !== undefined) {
                this.transparencyChanged(node.data.layertransparency, node);
            }
        }
        else {

            this.selectedlayers.splice(this.selectedlayers.indexOf(node), 1);
            this.es.sendUnSelectNode(node);
            this.tableOn(event, node);

        }
        //console.log(event)
        //console.log(node)   
        // this.es.sendSelectedNodeList(this.selectedlayers);
    }




    public transparencyChanged(event: any, node: any): void {

        var transparecy = event / 100;
        var ql = this.api.getLayerById(node.data.id);
        ql.setOpacity(transparecy);
    }

    public setLayerTransparency(e: any): void {
        //console.log(e);
    }

    private buildSqlForCql(): string {
        let cqlall = "";

        if (this.filters.area?.length > 0) {
            cqlall += this.filters.area + " and ";
        }

        if (this.filters.aditional?.length > 0) {
            cqlall += this.filters.aditional + " and ";
        }

        this.filters.inbuild
            .filter(v => v && v.length > 0)
            .forEach(v => {
                cqlall += v + " and ";
            });

        return cqlall.substring(0, cqlall.length - 5);
    }

    public doCqlFilter(e: any, i: any): void {
        console.warn("doCqlFilter", e);
        //console.log("index:"+i);
        if (e.value.node.data.areafilter) {
            this.filters.area = e.value.node.data.areafilter;
        }

        if (e.value.filtertype === "aditional") {
            this.filters.aditional = e.value.value;
        }
        else {
            this.filters.inbuild[i] = e.value.value;
        }
        var cqlall = this.buildSqlForCql();
        //console.log("cqlall:"+cqlall);

        var ql = this.api.getLayerById(e.value.node.data.id);

        if (ql !== null && ql.getSource() != null) {

            if (cqlall.length > 0) {
                ql.getSource().updateParams({
                    CQL_FILTER: cqlall,
                    _ck: Date.now()
                });
            } else {
                ql.getSource().updateParams({
                    CQL_FILTER: undefined,
                    _ck: Date.now()
                });
            }

            if (typeof ql.getSource().refresh === 'function') {
                ql.getSource().refresh();
            }
            
            e.value.node.data.cqlsetFilter = encodeURIComponent(cqlall);
            //console.log(cqlall);
            e.value.node.csvurl = this.ls.getGeoJsonWithCql(e.value.node.data.url, e.value.node.data.layer, e.value.node.data.cqlsetFilter);

            /*replace td with filtered ...*/
            if (e.value.node.data.tableOn !== undefined && e.value.node.data.tableOn) {


                this.tableService.getData(this.ls.getGeoJsonWithCql(e.value.node.data.url, e.value.node.data.layer, e.value.node.data.cqlsetFilter)).subscribe(r => {
                    var s = this.api.geojson2FeatureSource(r);
                    var to = this.api.parseTableDataWFS_WMS(s, e.value.node.data.id);
                    if (to.data.length > 0) {
                        this.tableService.setTableData({ data: to.data, fields: to.fields, selectedItem: null, id: e.value.node.data.id, visible: e.value.node.data.tableOn, label: e.value.node.label, node: e.value.node });
                        e.value.node.data.tabledataloaded = true;
                    }

                },
                    err => {
                        console.log(err)
                    });
            }

        }

        // console.log("cql set:"+e.value.value);
    }



    private setCqlFilter(node: any): void {

        // Naselja dropdown
        if (this.naseljaCqlDropBoxVals.length > 0 && node.naseljaCqlDropBoxVals === undefined) {
            node.naseljaCqlDropBoxVals = [];
            node.naseljaCqlDropBoxVals.push({ label: "Vsa naselja", value: { value: "", node: node, filtertype: "aditional" } });

            for (let n of this.naseljaCqlDropBoxVals) {
            node.naseljaCqlDropBoxVals.push({
                label: n.na_uime,
                value: { value: "_na_mid=" + n.na_mid, node: node, filtertype: "aditional" }
            });
            }

            // default selection = first option ("Vsa naselja")
            if (node.naseljaSelected === undefined) {
            node.naseljaSelected = node.naseljaCqlDropBoxVals[0].value;
            }
        }

        // Inbuild CQL dropdowns
        if (node.data.cql && node.cqlDropBoxes === undefined) {
            node.cqlDropBoxes = [];
            node.cqlSelected = []; 

            for (let i = 0; i < node.data.cql.length; i++) {
            const cqaval = node.data.cql[i];

            const cqlDropBoxVals = [];
            cqlDropBoxVals.push({ label: "Vsi", value: { value: "", node: node, filtertype: "inbuild" } });

            for (let cq of cqaval) {
                cqlDropBoxVals.push({ label: cq.name, value: { value: cq.val, node: node, filtertype: "inbuild" } });
            }

            node.cqlDropBoxes.push(cqlDropBoxVals);

            if (node.cqlSelected[i] === undefined) {
                node.cqlSelected[i] = cqlDropBoxVals[0].value;
            }
            }
        }
    }

    private checkTreeAutoOnLayers(nodes: any): void {
        if (!Array.isArray(nodes) || nodes.length === 0) {
            return;
        }

        for (const n of nodes) {
            if (n.checked !== undefined && n.checked) {
                n.selected = true;
                this.nodeSelect({ checked: true }, n);
            }

            if (Array.isArray(n.children) && n.children.length > 0) {
                this.checkTreeAutoOnLayers(n.children);
            }
        }
    }

    private onOffLayersByID(id: any, on: boolean, nodes: any, updateTree = false): void {
        if (!Array.isArray(nodes) || nodes.length === 0) {
            return;
        }

        for (const n of nodes) {
            if (n?.data?.id == id) {
                n.data.ison = on;
                n.data.aclass = on ? 'activeLayer' : 'notActiveLayer';

                const layer = this.api.getLayerById(id);
                if (layer != null) {
                    layer.setVisible(on);

                    if (!on) {
                        this.api.unselectFeatureForLayer(layer);
                    }
                }

                if (updateTree) {
                    n.selected = on;
                    this.nodeSelect({ checked: on }, n);
                }

                return;
            }

            if (Array.isArray(n?.children) && n.children.length > 0) {
                this.onOffLayersByID(id, on, n.children, updateTree);
            }
        }
    }

    private filterJavneStavbeLayers(nodes: TreeNode[], obMid: number): TreeNode[] {
        const isMol = Number(obMid) === 11027849;
        const normalId = Number(this.gs.getJavneStavbeLayerId());
        const molId = Number(this.gs.getJavneStavbeMolLayerId());

        return (nodes || [])
            .map((node: any) => {
                if (node.children?.length) {
                    node.children = this.filterJavneStavbeLayers(node.children, obMid);
                }

                const id = Number(node?.data?.id);

                if (isMol && id === normalId) {
                    return null;
                }

                if (!isMol && id === molId) {
                    return null;
                }

                return node;
            })
            .filter((node: any) => node !== null);
    }


    ngOnInit() {
        var self = this;


        this.es.subscribeTreeNodeOnOffEvtListener().subscribe(d => {
            if (!Array.isArray(self.layerslist)) {
                return;
            }

            if (d.visibilityOnly) {
                const layer = this.api.getLayerById(d.id);

                if (layer) {
                    layer.setVisible(!!d.ison);

                    if (!d.ison) {
                        this.api.unselectFeatureForLayer(layer);
                    }
                }

                return;
            }

            if (d.removeFromTree) {
                // križec
                self.onOffLayersByID(d.id, false, self.layerslist, true);
                return;
            }
            // eye
            self.onOffLayersByID(d.id, d.ison, self.layerslist, false);
        });



        this.ls.subscribeLayersGroupLoadListener().subscribe(
            data => {
                if (data.ob_mids !== undefined) {
                    //console.log("load layer group ob mid:"+data.ob_mid);
                    //console.log("call naselja");
                    //console.log(data);
                    self.es.sendMidChangeEvt(data);
                    //self.layerslist = self.ls.getTestLayer();
                    self.tableService.setCountVisibleTable(0);
                    self.naseljaCqlDropBoxVals = [];
                    self.tableService.getData(this.gs.getRestUrl() + "/api/srch/settlements?obid=" + data.ob_mids, false).subscribe((r: any) => {

                        for (let n of r) {

                            self.naseljaCqlDropBoxVals = r;
                        }
                    });

                    self.es.setVisibleLegendsEvt(0);
                    self.ls.getDbJsonLayerTree(data.ob_mid).subscribe(j => {

                        self.layerslist = self.filterJavneStavbeLayers(j, data.ob_mid);
                        self.checkTreeAutoOnLayers(self.layerslist);
                    });

                }
                else {
                    console.log("load layer group error: data undefined ");

                }
            },
            err => { console.log(err) }

        );


    }

}
